import styled from '@emotion/styled';

export const HomeHeaderRealizedContainer = styled.div`
  width: 100%;
`;
